import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from '../actions/types';

const defaultState = null;

export default function notificationReducer(state = defaultState, action) {
	switch (action.type) {
		case ADD_NOTIFICATION:
			return action.payload;

		case REMOVE_NOTIFICATION:
			return null;

		default:
			return state;
	}
}
